import { notification } from "antd";
import { handleError } from "./handleError";

export const showMessage = (
  type: "error" | "success",
  messageTitle: string,
  messageText?: string,
  error?: any
): void => {
  if (type === "success") {
    notification.success({
      message: messageTitle,
      description: messageText,
      duration: 15
    });
  } else {
    handleError(messageText, error);
  }
};